export function extractAllUniqueImageIdsFromMarkdownString(inputString: string) {
    const pattern = /!\[([^\]]+)\]/g;
    const matches = [...inputString.matchAll(pattern)];
    return matches.map(match => match[1]);
}
